module.exports = __webpack_public_path__ + "static/media/imagePagePlaceholderLeadCapture.808c36c8.svg";